import QueryString from "qs";
import SoftwareSolution from "@/Components/pages/software-solution";
import { GetServerSideProps, NextPage } from "next";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface BlogDetailProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
  isMobile: boolean;
}
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = (ctx?.params?.slug as string) ?? "";

  const userAgent = ctx.req.headers["user-agent"] || "";
  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

  let isOldPagev14 = false;
  const isNew = false;

  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep,8",
    },
    {
      encodeValuesOnly: false,
    }
  );

  let apiRes = await fetch(
    `${baseUrl}v2-software-solutions?${decodeURIComponent(query)}`
  );

  let apiResData = await apiRes.json();

  if (!apiResData?.data?.length) {
    apiRes = await fetch(`${baseUrl}crm-pages?${decodeURIComponent(query)}`);
    isOldPagev14 = true;
    apiResData = await apiRes.json();
  }

  return {
    props: {
      apiResData,
      isNew,
      slug,
      isMobile,
      isOldPagev14,
    },
  };
};

const Crm: NextPage<BlogDetailProps> = ({ apiResData, slug, isMobile }) => {
  const seo = apiResData?.data[0]?.attributes?.seo?.[0];
  const blocks = apiResData?.data[0]?.attributes?.blocks;
  const breadcrumbs = apiResData?.data[0]?.attributes?.breadcrumbs ?? {};

  return (
    <div id="root">
      <SoftwareSolution
        data={blocks}
        isMobile={isMobile}
        seo={seo}
        slug={slug}
        breadcrumbs={breadcrumbs}
      />
    </div>
  );
};

export default Crm;
